"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  data: function data() {
    return {
      tableData: {
        data: [],
        total: 0
      },
      listLoading: false,
      keyNum: 0,
      id: 0
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['admin:product:guarantee:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 列表
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _store.guaranteeListApi)().then(function (res) {
        _this2.tableData.data = res;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.$message.error(err.message);
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    handlerOpenEdit: function handlerOpenEdit(isCreate, editDate) {
      var _this = this;
      this.id = editDate ? editDate.id : 0;
      this.$modalParserFrom(isCreate === 0 ? '添加服务条款' : '编辑服务条款', '保障服务', isCreate, isCreate === 0 ? {} : Object.assign({}, editDate), function (formValue) {
        _this.submit(formValue);
      }, this.keyNum += 4);
    },
    submit: function submit(formValue) {
      var _this3 = this;
      var data = {
        id: this.id,
        name: formValue.name,
        content: formValue.content,
        icon: formValue.icon,
        sort: formValue.sort,
        isShow: formValue.isShow
      };
      !this.id ? (0, _store.guaranteeAddApi)(data).then(function (res) {
        _this3.$message.success('操作成功');
        _this3.$msgbox.close();
        _this3.getList();
      }).catch(function () {
        _this3.loading = false;
      }) : (0, _store.guaranteeUpdateApi)(data).then(function (res) {
        _this3.$message.success('操作成功');
        _this3.$msgbox.close();
        _this3.getList();
      }).catch(function () {
        _this3.loading = false;
      });
    },
    handlerOpenDel: function handlerOpenDel(rowData) {
      var _this4 = this;
      this.$modalSure('删除当前保障服务吗').then(function () {
        (0, _store.guaranteeDelApi)(rowData.id).then(function (data) {
          _this4.$message.success('删除成功');
          _this4.getList();
        });
      });
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this5 = this;
      (0, _store.guaranteeUpdateShowApi)(row.id).then(function () {
        _this5.$message.success('操作成功');
        _this5.getList();
      });
    }
  }
};